export const config = {
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL || '',
    anonKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || '',
    projectId: import.meta.env.VITE_SUPABASE_PROJECT_ID || '',
  },
  app: {
    name: 'Fondation Imam Mouhamadou Sakhir',
    description: 'Site officiel de la Fondation Imam Mouhamadou Sakhir',
    defaultLanguage: 'fr',
    supportedLanguages: ['fr', 'en', 'ar'],
  },
  contact: {
    email: 'contact@fondation-imam-sakhir.org',
    phone: '+221 33 123 45 67',
    address: 'Dakar, Sénégal',
  },
  social: {
    facebook: 'https://facebook.com/fondation-imam-sakhir',
    twitter: 'https://twitter.com/fondation_ims',
    instagram: 'https://instagram.com/fondation_ims',
    youtube: 'https://youtube.com/@fondation-imam-sakhir',
  },
  donation: {
    minAmount: 1000, // en francs CFA
    defaultCurrency: 'XOF',
    paymentMethods: ['wave', 'orange_money', 'credit_card', 'bank_transfer'],
  },
} as const;

export type AppConfig = typeof config;
